module.exports = __webpack_public_path__ + "img/108.7e98e8aa.jpg";